import React, { useCallback, useEffect, useState } from "react";
import MobileDetect from "mobile-detect";

const parseItem = (item, imgProps = {}) => {
  if (typeof item === "string") {
    return <img src={item} alt="" {...imgProps} />;
  }
  if (typeof item === "function") {
    return item();
  }
  return item;
};

const toggleClassName = (
  c1,
  c2,
  isC1,
  classList = window.document.documentElement.classList
) => {
  if (isC1) {
    classList.remove(c2);
    classList.add(c1);
  } else {
    classList.remove(c1);
    classList.add(c2);
  }
};

export const useHtmlClassList = (className) => {
  useEffect(() => {
    if (className) {
      window.document.documentElement.classList.add(className);
    }

    return () => {
      if (className) {
        window.document.documentElement.classList.remove(className);
      }
    };
  }, [className]);
};

export const useBrowserLayout = ({
  designWidth = 1290,
  designHeight = 2796,
  designRatio = 1.24,
  appWidth = 800,
} = {}) => {
  const [isAppLayout, setIsAppLayout] = useState();
  const [isMobileLayout, setIsMobileLayout] = useState();
  const [isMobile, setIsMobile] = useState();
  const [isWXBrowser, setIsWXBrowser] = useState(false);
  const [md, setMd] = useState();
  const [isNative, setIsNative] = useState();

  // 检查浏览器信息
  useEffect(() => {
    setIsNative(!!window.ReactNativeWebView);
    toggleClassName("is_native", "is_notNative", !!window.ReactNativeWebView);
    const md = new MobileDetect(window.navigator.userAgent);
    const mobile = !!md.mobile();
    setMd(md);
    setIsWXBrowser(
      /micromessenger/.test(window.navigator.userAgent.toLowerCase())
    );
    setIsMobile(mobile);

    toggleClassName("is_mobile", "is_desktop", mobile);
    if (mobile) {
      // ios safari 的导航条会挡住底部
      setTimeout(() => {
        const viewH = window.innerHeight; // 浏览器的视窗高度
        const pageH = window.document.documentElement.offsetHeight; // 页面高度
        if (pageH > viewH) {
          // 以便 css 那边做缩放，将导航条的部分流出来
          document.documentElement.style.setProperty(
            "--scale-for-safari",
            viewH / pageH
          );
        }
      }, 300);
    }
  }, []);

  useEffect(() => {
    const resizeEvent = () => {
      const winWidth = window.document.documentElement.clientWidth;
      const isApp = winWidth < appWidth;
      toggleClassName("is_app", "is_notApp", isApp);
      window.document.documentElement.classList.add("theme-disabled");
      setIsAppLayout(isApp);
    };
    resizeEvent();
    window.addEventListener("resize", resizeEvent);

    return () => {
      window.removeEventListener("resize", resizeEvent);
    };
  }, [appWidth]);

  // 检测网页是否近似手机比例
  useEffect(() => {
    const resize = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      const matchRatio = w / h <= (designWidth * designRatio) / designHeight;
      setIsMobileLayout(matchRatio);
      // console.log(
      //   (w / h).toFixed(2),
      //   (designWidth / designHeight).toFixed(2),
      //   ((designWidth * designRatio) / designHeight).toFixed(2)
      // );
    };

    window.addEventListener("resize", resize);
    resize();

    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [designWidth, designHeight, designRatio]);

  // 为手机比例的网页添加 class
  useEffect(() => {
    toggleClassName("is_matchRatio", "is_notMatchRatio", isMobileLayout);
  }, [isMobileLayout]);

  const renderItem = useCallback(
    (
      forPc,
      forApp,
      { mode = "app", imgProps = {}, placeholder = null } = {}
    ) => {
      const isLayout = {
        app: isAppLayout,
        mobile: isMobileLayout,
        mobileDevice: isMobile,
      }[mode];

      if (isLayout === undefined) {
        return placeholder || null;
      }

      if (isLayout) {
        return parseItem(forApp, imgProps);
      }

      return parseItem(forPc, imgProps);
    },
    [isAppLayout, isMobileLayout, isMobile]
  );

  return {
    md,
    isMobile,
    isMobileLayout,
    isAppLayout,
    isWXBrowser,
    renderItem,
    isNative,
  };
};
